export default "__VITE_ASSET__DMXptC1$__"